import { handleActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = {}

export default handleActions(
  {
    [rawActions.updatePdfSearchResults](state, action) {
      return action.payload
    },
    [rawActions.clearPdfSearchResults](state, action) {
      return defaultState
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
